<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/cgt.png">
    <NRP msg="CGT Burgos - Educación" app_name="Calculadora de NRP" :app_version="version"/>
  </div>
</template>

<script>

import NRP from './components/NRPForm.vue';
const appVersion = require('../package.json').version;

const data = () => ({ version: appVersion });

export default {
  name: 'App',
  data,
  components: { NRP }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin-top: 60px;
}
</style>
